export default "https://assets.pclncdn.com/web/next-landing/80a0a33/_next/static/images/cobrand-cruise411-promo-0f70208be79fe82fbcafdaa2e3603329.jpg";